import React from 'react'

interface ExpiredInvitationProps {
  invitation?: Record<string, unknown>
  adminEmail?: string
}

const ExpiredInvitation = ({ adminEmail }: ExpiredInvitationProps): React.ReactElement => {
  const expiredTime = '2 days ago'

  return (
    <div>
      <h2>Invitation Expired</h2>
      <p>
        Your invite expired {expiredTime}. Please contact admin ({adminEmail}) to request another invite.
      </p>
    </div>
  )
}

export default ExpiredInvitation
